import { useMemo } from "react";
import { MemberHistoryDto } from "../../../../../../../api/member";
import {
  WalletHistoryItemInfoWrapper,
  WalletHistoryItemWrapper,
  WalletHistoryItemMainWrapper,
  WalletHistoryItemBase,
  WalletHistoryItemPub,
  WalletHistoryItemRank,
  WalletHistoryInfoItem,
} from "./style";

interface WalletHistoryItemProps {
  item: MemberHistoryDto;
  isSelected: boolean;
  setSelectedId: (v: number) => void;
}

const WalletHistoryItem = ({
  item,
  isSelected,
  setSelectedId,
}: WalletHistoryItemProps) => {
  const InfoHeader = useMemo(() => {
    switch (item.pubType) {
      case "VIP":
        return [
          { name: "리앤트리", value: item.reBuyInCount?.toLocaleString() },
          { name: "애드온", value: item.addOnCount?.toLocaleString() },
          {
            name: "사용포인트",
            value: item.totalPointsSpent?.toLocaleString(),
          },
          { name: "획득포인트", value: item.pointsWon?.toLocaleString() },
        ];
      case "FRANCHISE":
        return [
          { name: "리앤트리", value: item.reBuyInCount?.toLocaleString() },
          { name: "애드온", value: item.addOnCount?.toLocaleString() },
          {
            name: "획득 랭킹 포인트",
            value: (item.rankPoint / 100).toFixed(2),
          },
        ];
      case "RUNNER":
        return [
          { name: "총 앤트리", value: item.totalEntry?.toLocaleString() },
          {
            name: "획득 랭킹 포인트",
            value: (item.rankPoint / 100).toFixed(2),
          },
        ];
    }
  }, [item]);

  const handleItemClick = () => {
    if (isSelected) {
      setSelectedId(-1);
      return;
    }
    setSelectedId(item.id);
  };

  const formatDate = () => {
    const date = new Date(item.createdAt);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}.${month}.${day}`;
  };

  return (
    <WalletHistoryItemWrapper onClick={handleItemClick} isSelected={isSelected}>
      <WalletHistoryItemMainWrapper>
        <WalletHistoryItemBase>
          <div className="date">{formatDate()}</div>
          <WalletHistoryItemPub>
            <div className="pub">{item.pubName}</div>
            <div className="tournament">{item.tournamentTitle}</div>
          </WalletHistoryItemPub>
        </WalletHistoryItemBase>
        <WalletHistoryItemRank>
          <img src="/image-web/human.svg" alt="" />
          <div className="rank">
            {item.tournamentEntry}/{item.rank ? item.rank : "-"}위
          </div>
        </WalletHistoryItemRank>
      </WalletHistoryItemMainWrapper>
      <WalletHistoryItemInfoWrapper isSelected={isSelected}>
        {InfoHeader?.map((item, index) => (
          <WalletHistoryInfoItem key={index}>
            <div className="name">{item.name}</div>
            <div className="value">{item.value}</div>
          </WalletHistoryInfoItem>
        ))}
      </WalletHistoryItemInfoWrapper>
    </WalletHistoryItemWrapper>
  );
};

export default WalletHistoryItem;
